<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="p-0 m-0" v-bind:class="{'card-group-control card-group-control-left':enabled}" v-bind:id="'accordion-control' + getId()">
    <div class="card shadow-0 p-0 m-0 border-0">
      <div class="card-header" v-if="enabled == true">
        <h6 class="card-title">
          <a data-toggle="collapse" class="text-default collapsed " v-bind:href="'#accordion-control' + getId()  + '-group1'" aria-expanded="false">{{el.Text}}</a>
        </h6>
      </div>
      <div v-bind:id="'accordion-control' + getId() + '-group1'" class="p-0 m-0"  v-bind:class="{'collapse collapsed': show == 'true' && enabled == true}" v-bind:data-parent="'#accordion-control' + getId()">
        <div class="card-body p-0" v-bind:class="{'expand-border' : enabled}">
          <slot></slot>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>

  export default {
    name: 'procedure-expand',
    components: {
    },
    props: {
      el: {
        required: false,
        type: Object,
        default: {Text: ''}
      },
      title: {
        required: false,
        type: String,
        default: null
      },
      show: {
        required: false,
        type: String,
        default: 'false'
      },
      enabled: {
        required: false,
        type: Boolean,
        default: false
      }
    },
    methods: {
      getId() {
        return this._uid;
      },
      handleRefresh(val) {
        this.$forceUpdate();
      }
    },
    created() {
      this.$root.$on('procedure_refresh', this.handleRefresh);
    },
    mounted() {
    }
  }
</script>


<style scoped>

  .card {
    background-color: initial;
  }

  a {
    color: inherit !important;
  }

  .expand-border {
    border-left: 5px solid #cbcccc !important;
    margin-left: 25px !important;
    margin-bottom:10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-view-expand.vue